export default __webpack_public_path__ + "static/media/Roobert-Light.47cf9662.woff";